export { auditApi } from './api';
export type { AuditEntry, AuditFilters, AuditTargetType } from './types';

export const KNOWN_AUDIT_ACTIONS = [
  'iam.UserRegistered',
  'iam.UserVerified',
  'iam.UserBlocked',
  'iam.KycStatusChanged',
  'manufacturer.ProfileCreated',
  'catalog.ProductSubmitted',
  'catalog.ProductPublished',
  'catalog.ProductRejected',
  'rfq.BuyRequestPublished',
  'rfq.BuyRequestHidden',
  'rfq.QuoteSubmitted',
  'rfq.QuoteAccepted',
  'order.OrderCreated',
  'order.OrderStatusChanged',
  'chat.MessageSent',
  'moderation.UserBlocked',
  'moderation.UserUnblocked',
] as const;
